<style>
    .example-full-width {
        width: 100%;
    }

    i {
        float: right;
    }
    button {
        background-color: #ff9800;
    }

    .settled {
        width: 20px;
    }

    .mat-dialog-actions {
        padding: 3px 0px 27px !important;
        display: flex;
        flex-wrap: wrap;
        min-height: 52px;
        align-items: center;
        margin-bottom: none !important;
    }
</style>

<div class="container dialog content-view">
    <i mat-dialog-close class="arrow-cursor">
        <mat-icon mat-button>clear</mat-icon>
    </i>
    <h1 mat-dialog-title> Request For Demo</h1>
    <form [formGroup]="requestDemo" [name]="requestDemo" autocomplete="off" fxLayout="column">
        <mat-form-field>
            <mat-label>Company Name</mat-label>
            <input matInput formControlName="companyname" class="input" required />
            <mat-icon matSuffix>account_balance</mat-icon>

            <mat-error *ngIf="requestDemo.get('companyname').hasError('required')">You must enter a value</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Email</mat-label>
            <input matInput placeholder="Email" formControlName="email" required />
            <mat-icon matSuffix>email</mat-icon>
            <mat-error *ngIf="requestDemo.get('email').hasError('required')">You must enter a value</mat-error>
            <mat-error *ngIf="email.invalid">{{ getEmailError() }}</mat-error>
        </mat-form-field>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="10%" fxLayoutAlign="center">

            <div fxFlex="50">
                <mat-form-field>
                    <mat-label>Required Experience</mat-label>
                    <mat-select matNativeControl formControlName="level" required>
                        <mat-option value="Fresher">Fresher</mat-option>
                        <mat-option value="Trainee">0-1 Years</mat-option>
                    </mat-select>
                    <mat-error *ngIf="requestDemo.get('level').hasError('required')">You must select a value</mat-error>
                </mat-form-field>
            </div>

            <div fxFlex="50">
                <mat-form-field>
                    <mat-label>Required Employees </mat-label>
                    <input matInput placeholder="Number of Employee" formControlName="employee" type="number" min="1"
                        required />
                    <mat-error *ngIf="requestDemo.get('employee').hasError('required')">You must select a value</mat-error>
                    <mat-error *ngIf="requestDemo.get('employee').hasError('max')">Limit reached</mat-error>
                </mat-form-field>
            </div>
        </div>
        <mat-form-field class="input-full-width">
            <mat-label>Requirement Description</mat-label>
            <textarea rows="8" matInput formControlName="description" placeholder='Description...' required
                minlength="10"></textarea>
            <mat-error *ngIf="description.invalid">{{ getDescriptionError() }}</mat-error>
        </mat-form-field>
    </form>
    <div mat-dialog-actions class="submit_button">
        <button mat-raised-button mat-dialog-close [disabled]="!requestDemo.valid" (click)="onsubmit()" color="warn"
            class="bold">
            Submit
        </button>
        <button mat-raised-button color="warn" mat-dialog-close class="bold">Cancel</button>
    </div>
</div>